import React, { Component } from 'react';
import { StyleSheet, Image, View } from 'react-native';

import OPComponent from '../op_component';
import Avatar from './avatar';

import { COLOR, FONT, FONT_SIZE } from '../../../constants/styles';

import { USER_PROFILE_PHOTO } from '../../../constants/objectTypes';

class ProfileAvatar extends OPComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.profile !== this.props.profile || nextProps.avatarUrl !== this.props.avatarUrl;
  }

  handlePress = () => {
    this.props.onPress && this.props.onPress(this.props.profile);
  };

  _lastName(name) {
    if (!name) return '';
    const nameArray = name.split(' ');
    return nameArray[nameArray.length - 1];
  }

  _firsttName(name) {
    if (!name) return '';
    const nameArray = name.split(' ');
    return nameArray[0];
  }

  render() {
    const {
      profile,
      avatarUrl,
      showNameLabel,
      circleStyles,
      containerStyles,
      onPress,
      isAirforce,
      initialsStr,
    } = this.props;

    const nameLabel =
      (showNameLabel &&
        (profile && isAirforce
          ? this._lastName(profile?.fullName)
          : this._firsttName(profile?.fullName))) ||
      '';

    const medicalService =
      profile?.employers && Object.values(profile.employers)[0]?.medicalService;

    const nameSubLabel =
      (showNameLabel && profile && isAirforce && (medicalService || profile?.rank)) || '';

    let attachment = null;
    if (profile && profile.avatarUrl) {
      attachment = {
        objectType: USER_PROFILE_PHOTO,
        objectId: profile.userId,
        fileName: profile.avatarUrl,
      };
    }

    const isOnCall = Object.keys(profile?.employers || {}).find(
      (k) => !!profile.employers[k].on_call
    );
    const onCallOffset = circleStyles?.height || 120;

    return (
      <Avatar
        circleStyles={circleStyles}
        containerStyles={containerStyles}
        initialsStr={initialsStr || (profile && profile.fullName)}
        nameLabel={nameLabel}
        nameSubLabel={nameSubLabel}
        withSublabel={!!isAirforce}
        onPress={onPress ? this.handlePress : null}
        avatarUrl={avatarUrl}
        attachment={attachment}
      >
        {!!isOnCall && (
          <View style={[styles.pagerIconContainer, { top: onCallOffset - 10 }]}>
            <Image
              style={[styles.pagerIcon]}
              source={require('../../../../resources/icon-pager-small.png')}
              resizeMode="contain"
            />
          </View>
        )}
      </Avatar>
    );
  }
}

const styles = StyleSheet.create({
  pagerIcon: {
    width: 11,
    height: 11,
  },
  pagerIconContainer: {
    backgroundColor: 'white',
    position: 'absolute',
    top: 40,
    width: 20,
    height: 20,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    shadowOpacity: 0.1,
    shadowRadius: 4,
    shadowColor: COLOR.shadow,
    shadowOffset: { height: 4, width: 0 },
    elevation: 2,
  },
});

export default ProfileAvatar;
